import { ShoppingCart } from "lucide-react";
import { Button } from "@/app/components/shadcn/button";
import Link from "next/link";

const BasketEmptyBanner = () => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 border rounded-xl px-5 py-4 bg-white">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-orange-50 flex items-center justify-center shrink-0">
          <ShoppingCart className="text-main" size={22} />
        </div>
        <p className="text-sm font-medium text-gray-700">
          Sepetinizde ürün bulunmamaktadır.
        </p>
      </div>
      <Button asChild variant="orange" className="shrink-0 w-full sm:w-auto">
        <Link href="/">Alışverişe Başla</Link>
      </Button>
    </div>
  );
};

export default BasketEmptyBanner;